import { trackEvent } from 'dibs-tracking';

const notificationNameMap = {
    PENDING_FEEDBACK: 'review purchase',
    VIEW_PROMO: 'view promo',
    VIEW_CONVERSATION: 'view conversation',
};

export function getNotificationName(nodeType) {
    return notificationNameMap[nodeType];
}

export function trackNotification(label, action) {
    trackEvent(
        {
            label,
            category: 'navigation',
            action: `header notifications notification ${action}`,
            isInteractiveEvent: false,
            value: 0,
        },
        null
    );
}
